import React, { useState, useContext } from 'react';
import { Card, Button, Tabs, Space, Typography, Row, Col, Form, Modal, Input, InputNumber, Select, Popconfirm, Tooltip, message } from 'antd';
import { LeftOutlined, RightOutlined, SettingOutlined, PlusOutlined, DeleteOutlined, WarningOutlined } from '@ant-design/icons';
import OctoopiLogo from './images/OctoopiLogo.png';
import VectorIcon from './images/Vector.png';
import VectorPowerButton from './images/VectorPowerButton.png';
import VectorOutputInput from './images/Vectoroutputinput.png';
import PikacuIcon from './images/pikacu.png';
import WaterIcon from './images/water.png';
import FloatIkon from './images/floatikon.png';

const { TabPane } = Tabs;
const { Text, Title } = Typography;


// PanelPreview bileşeni - gerçek ikonları props'dan alır

const PanelPreview = ({ 
  pages = [], 
  outputs = [], 
  inputs = [], 
  voltages = [], 
  floats = [],
  tempratures = [],
  translations = {},
  language = 'TR',
  icons = {}, // Icons'u prop olarak al
  onComponentClick,
  onEmptySlotClick,
  // Sayfa ayar fonksiyonları
  onPageSettingsChange,
  onAddPage,
  onDeletePage
}) => {
  const [selectedPage, setSelectedPage] = useState(1);
  
  // Sayfa ayar modalı için state'ler
  const [pageSettingsModalVisible, setPageSettingsModalVisible] = useState(false);
  const [editingPage, setEditingPage] = useState(null);
  const [form] = Form.useForm();

  console.log('Sample output data:', outputs[0]);
  console.log('Current language in PanelPreview:', language);
console.log('Language type:', typeof language);

  const t = (key) => {
  return translations[language]?.[key] || key;
};

// Sayfa ayarları fonksiyonları
const handleOpenPageSettings = (page) => {
  setEditingPage(page);
  form.setFieldsValue({
    name: page.name || "",
    first_row_capacity: page.first_row_capacity || 0,
    second_row_capacity: page.second_row_capacity || 0
  });
  setPageSettingsModalVisible(true);
};

const handleSavePageSettings = () => {
  form.validateFields().then(values => {
    // Kapasite azaltılıyorsa kontrol et
    const currentPage = pages.find(p => p.no === editingPage.no);
    
    // 1. Sıra kapasitesi kontrolü
    if (values.first_row_capacity < currentPage.first_row_capacity) {
      const usedItems = checkIfPositionUsedInCapacity(editingPage.no, 1, values.first_row_capacity);
      if (usedItems.length > 0) {
        showCapacityWarning(editingPage.no, 1, values.first_row_capacity, usedItems);
        return;
      }
    }
    
    // 2. Sıra kapasitesi kontrolü
    if (values.second_row_capacity < currentPage.second_row_capacity) {
      const usedItems = checkIfPositionUsedInCapacity(editingPage.no, 2, values.second_row_capacity);
      if (usedItems.length > 0) {
        showCapacityWarning(editingPage.no, 2, values.second_row_capacity, usedItems);
        return;
      }
    }
    
    const updatedPage = {
      ...editingPage,
      ...values
    };
    onPageSettingsChange && onPageSettingsChange(updatedPage);
    setPageSettingsModalVisible(false);
    setEditingPage(null);
    form.resetFields();
  });
};

const handleAddNewPage = () => {
  if (pages.length >= 10) {
    message.warning(`${t('maksimumeklenceksayfaondur')}`);
    return;
  }
  onAddPage && onAddPage();
};

const handleDeletePage = (pageNo) => {
  onDeletePage && onDeletePage(pageNo);
};

// Pozisyon kontrolü fonksiyonu - UserEditableJson'dakinin aynısı
const checkIfPositionUsedInCapacity = (pageNo, rowNo, proposedCapacity) => {
  const usedItems = [];
  const allItems = [
    ...outputs.map((item, index) => ({ ...item, type: 'output', index: index + 1 })),
    ...inputs.map((item, index) => ({ ...item, type: 'input', index: index + 1 })),
    ...voltages.map((item, index) => ({ ...item, type: 'voltage', index: index + 1 })),
    ...floats.map((item, index) => ({ ...item, type: 'float', index: index + 1 }))
  ];

  // Ana pozisyonları kontrol et
  allItems.forEach(item => {
    if (item.page === pageNo && item.row === rowNo) {
      if (item.column > proposedCapacity) {
        usedItems.push(`${item.type} ${item.index} (Kolon ${item.column})`);
      }
    }
  });

  // Clone pozisyonlarını kontrol et
  allItems.forEach(item => {
    if (item.cloneActive && item.page2 === pageNo && item.row2 === rowNo) {
      if (item.column2 > proposedCapacity) {
        usedItems.push(`${item.type} ${item.index} Clone (Kolon ${item.column2})`);
      }
    }
  });

  return usedItems;
};

// Güzel bir uyarı modalı göster
const showCapacityWarning = (pageNo, rowNo, proposedCapacity, usedItems) => {
  const itemsList = usedItems.join(', ');
  Modal.warning({
    title: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <WarningOutlined style={{ color: '#faad14', fontSize: '22px' }} />
        <span>{t('kapesitazaltılamıyor')}</span>
      </div>
    ),
    content: (
      <div style={{ marginTop: '16px' }}>
        <p style={{ fontSize: '15px', marginBottom: '12px' }}>
          <strong>{t('sayfaymışprew')} {pageNo} - {rowNo === 1 ? '1. Sıra' : '2. Sıra'}</strong> {t('kepesitesi')} <strong>{proposedCapacity}</strong>{t('düşürmelişmiş')}
        </p>
        <div style={{ 
          backgroundColor: '#fff7e6', 
          border: '1px solid #ffd591',
          borderRadius: '6px',
          padding: '12px',
          marginBottom: '12px'
        }}>
          <p style={{ margin: 0, fontWeight: '500', marginBottom: '8px' }}>
            {t('bupoziyonaatanmış')}
          </p>
          <p style={{ margin: 0, color: '#d46b08', fontWeight: '600' }}>
            {itemsList}
          </p>
        </div>
        <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>
          {t('öncebuitmeleri')}
        </p>
      </div>
    ),
    okText: `${t('anlamışmış')}`,
    width: 500,
  });
};

// Kapasite artırma/azaltma fonksiyonları
const handleCapacityChange = (pageNo, rowType, operation) => {
  const page = pages.find(p => p.no === pageNo);
  if (!page) return;
  
  const field = rowType === 'first' ? 'first_row_capacity' : 'second_row_capacity';
  const currentValue = page[field] || 0;
  const rowNo = rowType === 'first' ? 1 : 2;
  
  let newValue;
  if (operation === 'increase') {
    newValue = Math.min(currentValue + 1, 5); // Maksimum 5
    
    // Maksimum kapasiteye ulaşıldıysa uyar
    if (currentValue >= 5) {
      message.warning(`${t('Maksimummuşş')}`);
      return;
    }
  } else {
    const minValue = rowType === 'second' ? -1 : 0; // Sadece 2. sırada -1'e inebilir
    newValue = Math.max(currentValue - 1, minValue);
  }
  
  // Kapasite azaltılıyorsa kontrol et
  if (newValue < currentValue) {
    const usedItems = checkIfPositionUsedInCapacity(pageNo, rowNo, newValue);
    
    if (usedItems.length > 0) {
      showCapacityWarning(pageNo, rowNo, newValue, usedItems);
      return; // Değişikliği engelle
    }
  }
  
  const updatedPage = {
    ...page,
    [field]: newValue
  };
  
  onPageSettingsChange && onPageSettingsChange(updatedPage);
};

const [hoveredComponent, setHoveredComponent] = useState(null);



  

  // Tüm bileşenleri birleştir ve sayfa bazında grupla
const getAllComponents = () => {
  const allComponents = [];
  
  // Dil kodunu büyük harfe çevir (tr -> TR, en -> EN gibi)
  const langCode = language.toUpperCase();
  
  // Outputs ekle
  outputs.forEach(output => {
    if (output.socketpin && output.page && output.row && output.column) {
      // Dil bazlı isim seçimi
      let componentName = output.nameTR || 'Output';
      if (langCode === 'EN') {
        componentName = output.nameGB || output.nameTR || 'Output';
      } else if (langCode === 'DE') {
        componentName = output.nameDE || output.nameTR || 'Output';
      }
      
      allComponents.push({
        ...output,
        type: 'output',
        id: `output-${output.socketpin}`,
        name: componentName
      });
      
      // Clone varsa onu da ekle
      if (output.cloneActive && output.page2 && output.row2 && output.column2) {
        allComponents.push({
          ...output,
          type: 'output',
          id: `output-clone-${output.socketpin}`,
          page: output.page2,
          row: output.row2,
          column: output.column2,
          name: componentName,
          isClone: true
        });
      }
    }
  });

  // Inputs ekle
  inputs.forEach(input => {
    if (input.socketpin && input.page && input.row && input.column) {
      let componentName = input.nameTR || 'Input';
      if (langCode === 'EN') {
        componentName = input.nameGB || input.nameTR || 'Input';
      } else if (langCode === 'DE') {
        componentName = input.nameDE || input.nameTR || 'Input';
      }
      
      allComponents.push({
        ...input,
        type: 'input',
        id: `input-${input.socketpin}`,
        name: componentName
      });
      
      if (input.cloneActive && input.page2 && input.row2 && input.column2) {
        allComponents.push({
          ...input,
          type: 'input',
          id: `input-clone-${input.socketpin}`,
          page: input.page2,
          row: input.row2,
          column: input.column2,
          name: componentName,
          isClone: true
        });
      }
    }
  });

  // Voltages ekle
  voltages.forEach(voltage => {
    if (voltage.socketpin && voltage.page && voltage.row && voltage.column) {
      let componentName = voltage.nameTR || 'Voltage';
      if (langCode === 'EN') {
        componentName = voltage.nameGB || voltage.nameTR || 'Voltage';
      } else if (langCode === 'DE') {
        componentName = voltage.nameDE || voltage.nameTR || 'Voltage';
      }
      
      allComponents.push({
        ...voltage,
        type: 'voltage',
        id: `voltage-${voltage.socketpin}`,
        name: componentName
      });
      
      if (voltage.cloneActive && voltage.page2 && voltage.row2 && voltage.column2) {
        allComponents.push({
          ...voltage,
          type: 'voltage',
          id: `voltage-clone-${voltage.socketpin}`,
          page: voltage.page2,
          row: voltage.row2,
          column: voltage.column2,
          name: componentName,
          isClone: true
        });
      }
    }
  });

  // Floats ekle
  floats.forEach(float => {
    if (float.socketpin && float.page && float.row && float.column) {
      let componentName = float.nameTR || 'Float';
      if (langCode === 'EN') {
        componentName = float.nameGB || float.nameTR || 'Float';
      } else if (langCode === 'DE') {
        componentName = float.nameDE || float.nameTR || 'Float';
      }
      
      allComponents.push({
        ...float,
        type: 'float',
        id: `float-${float.socketpin}`,
        name: componentName
      });
      
      if (float.cloneActive && float.page2 && float.row2 && float.column2) {
        allComponents.push({
          ...float,
          type: 'float',
          id: `float-clone-${float.socketpin}`,
          page: float.page2,
          row: float.row2,
          column: float.column2,
          name: componentName,
          isClone: true
        });
      }
    }
  });

  return allComponents;
};

  // Belirli bir sayfa ve konumdaki bileşeni getir
  const getComponentAtPosition = (page, row, column) => {
    const allComponents = getAllComponents();
    return allComponents.find(comp => 
      comp.page === page && comp.row === row && comp.column === column
    );
  };

  // Sabit boyut hesaplama fonksiyonu
  const getComponentSize = (capacity) => {
    return { width: "115px", height: "115px" }; // Sabit boyut
  };

  // Sabit icon boyutu hesaplama
  const getIconSize = (capacity) => {
    return { width: "66.67px", height: "66.67px", iconSize: "66.67px" }; // Sabit boyut
  };

  // Sabit gap
  const getGap = (capacity) => {
    return "10px"; // Sabit gap
  };

  

  // Sayfa render et
  const renderPage = (page) => {
    const pageData = pages.find(p => p.no === page);
    if (!pageData) return null;

    const firstRowCapacity = pageData.first_row_capacity || 0;
    const secondRowCapacity = pageData.second_row_capacity || 0;

    const firstRowSize = getComponentSize(firstRowCapacity);
    const secondRowSize = getComponentSize(secondRowCapacity);
    
    const firstRowIconSize = getIconSize(firstRowCapacity);
    const secondRowIconSize = getIconSize(secondRowCapacity);
    
    const firstRowGap = getGap(firstRowCapacity);
    const secondRowGap = getGap(secondRowCapacity);

    return (
      <div style={{
        border: '2px solid #d9d9d9',
        borderRadius: '12px',
        padding: '10px 5px',
        minHeight: '450px',
        maxHeight: '450px',
        backgroundColor: '#000000',
        position: 'relative',
        overflow: 'hidden' // Taşmayı önle
      }}>
        {/* Kapasite Kontrolleri - En Üstte */}
        <div style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          marginBottom: "10px",
          position: "relative",
          zIndex: 2
        }}>
            {/* 1. Sıra Kontrolleri */}
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "4px 10px",
              border: "1px solid #3a3a3a",
              borderRadius: "6px",
              backgroundColor: "#1a1a1a"
            }}>
              <span style={{ fontSize: "11px", fontWeight: "500", color: "#aaaaaa" }}>{t('birincisırapageprewiew')}</span>
              <Button
                type="text"
                size="small"
                onClick={() => handleCapacityChange(page, "first", "decrease")}
                disabled={firstRowCapacity <= 0}
                style={{ padding: "0 5px", height: "20px", minWidth: "20px", fontSize: "16px", fontWeight: "bold", color: "#4dabf7", lineHeight: "1" }}
              >
                -
              </Button>
              <span style={{ fontSize: "13px", fontWeight: "bold", minWidth: "16px", textAlign: "center", color: "#ffffff" }}>
                {firstRowCapacity}
              </span>
              <Button
                type="text"
                size="small"
                onClick={() => handleCapacityChange(page, "first", "increase")}
                disabled={firstRowCapacity >= 8}
                style={{ padding: "0 5px", height: "20px", minWidth: "20px", fontSize: "16px", fontWeight: "bold", color: "#4dabf7", lineHeight: "1" }}
              >
                +
              </Button>
            </div>

            {/* 2. Sıra Kontrolleri */}
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "4px 10px",
              border: "1px solid #3a3a3a",
              borderRadius: "6px",
              backgroundColor: "#1a1a1a"
            }}>
              <span style={{ fontSize: "11px", fontWeight: "500", color: "#aaaaaa" }}>{t('ikincisırapageprewiew')}</span>
              <Button
                type="text"
                size="small"
                onClick={() => handleCapacityChange(page, "second", "decrease")}
                disabled={secondRowCapacity <= -1}
                style={{ padding: "0 5px", height: "20px", minWidth: "20px", fontSize: "16px", fontWeight: "bold", color: "#4dabf7", lineHeight: "1" }}
              >
                -
              </Button>
              <span style={{ fontSize: "13px", fontWeight: "bold", minWidth: "16px", textAlign: "center", color: "#ffffff" }}>
                {secondRowCapacity}
              </span>
              <Button
                type="text"
                size="small"
                onClick={() => handleCapacityChange(page, "second", "increase")}
                disabled={secondRowCapacity >= 8}
                style={{ padding: "0 5px", height: "20px", minWidth: "20px", fontSize: "16px", fontWeight: "bold", color: "#4dabf7", lineHeight: "1" }}
              >
                +
              </Button>
            </div>

          </div>

        {/* Vector İkon - Sağ */}
        <img
          src={VectorIcon}
          alt="Vector Icon"
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            width: '36px',
            height: '36px',
            objectFit: 'contain',
            opacity: 1,
            zIndex: 1
          }}
        />

        {/* Octoopi Logo - Sol */}
        <img
          src={OctoopiLogo}
          alt="Octoopi Logo"
          style={{
            position: 'absolute',
            top: '8px',
            left: '20px',
            width: '160px',
            height: '44.94px',
            objectFit: 'contain',
            opacity: 1,
            zIndex: 1
          }}
        />

        {/* Sıcaklık sensörleri - Orta alt, sol önce sağ sonra sıralı */}
        <div style={{ position: 'absolute', bottom: '8px', left: 0, right: 0, display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '16px' }}>
          {[...tempratures]
            .filter(temp => temp.enable === 'true')
            .sort((a, b) => (a.side === 'left' ? -1 : 1) - (b.side === 'left' ? -1 : 1))
            .map((temp, idx) => (
              <div key={`temp-${idx}`} style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                height: '52px',
                padding: '0 14px',
                backgroundColor: 'transparent',
              }}>
                {icons[temp.icon] && (
                  <img src={icons[temp.icon]} alt="temp" style={{ width: '28px', height: '28px', flexShrink: 0 }} />
                )}
                <span style={{ fontSize: '17px', fontWeight: '600', color: '#ffffff', whiteSpace: 'nowrap' }}>
                  24°C
                </span>
              </div>
            ))}
        </div>

        {/* Sıralar - dikey ortalama wrapper */}
        <div style={
          (firstRowCapacity < 0 || secondRowCapacity < 0)
            ? { position: 'absolute', top: '70px', bottom: '70px', left: 0, right: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '8px' }
            : { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }
        }>

        {/* İlk sıra - Kompakt */}
        {firstRowCapacity > 0 && (
          <div style={{ marginTop: '4px', marginBottom: '12px' }}>
            <Text style={{ fontSize: '12px', color: '#666', fontWeight: 'bold' }}>{t('birincisıra')} </Text>
            <div style={{ 
              display: 'flex', 
              gap: firstRowGap, 
              marginTop: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              overflow: 'hidden' // Taşmayı önle
            }}>
              {Array.from({ length: firstRowCapacity }, (_, i) => {
                const component = getComponentAtPosition(page, 1, i + 1);
                return (
                 // Component render kısmında - İLK SIRA için div içine:
<div
  key={`row1-col${i + 1}`}
  onClick={() => component && onComponentClick && onComponentClick(component)}
  style={{
    width: firstRowSize.width,
    height: firstRowSize.height,
    border: '1px solid #2C2F3B',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: (component?.type === 'voltage' || component?.type === 'float') ? '#2325304D' : 'linear-gradient(225deg, #404040 0%, #202020 100%)',
    position: 'relative',
    cursor: component ? 'pointer' : 'default',
    transition: 'all 0.3s ease',
    boxShadow: component ? '0 4px 12px rgba(24, 144, 255, 0.15)' : '0 2px 8px rgba(0, 0, 0, 0.06)',
    flexShrink: 0,
  }}
>
  {component ? (
    <>

      {/* Voltage Göstergesi - Yarım Halka (SVG arc) */}
      {component.type === 'voltage' && (
        <svg
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }}
          viewBox="0 0 130 130"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id={`vg-${component.socketpin}`} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%"   stopColor="#FF0000" />
              <stop offset="35%"  stopColor="#FFD300" />
              <stop offset="65%"  stopColor="#7BFF00" />
              <stop offset="100%" stopColor="#00FF00" />
            </linearGradient>
          </defs>
          {/* Track (arka plan izi) */}
          <path
            d="M 11 65 A 54 54 0 0 1 119 65"
            stroke="rgba(255,255,255,0.08)"
            strokeWidth="11"
            fill="none"
            strokeLinecap="round"
          />
          {/* Renkli gösterge yayı */}
          <path
            d="M 11 65 A 54 54 0 0 1 119 65"
            stroke={`url(#vg-${component.socketpin})`}
            strokeWidth="11"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      )}

      {/* Power Button İkonu - Sağ üst (sadece output) */}
      {component.type === 'output' && (
        <img
          src={VectorPowerButton}
          alt="power"
          style={{
            position: 'absolute',
            top: '6.67px',
            right: '6.67px',
            width: `calc(${firstRowIconSize.iconSize} * 0.38)`,
            height: `calc(${firstRowIconSize.iconSize} * 0.38)`,
            opacity: 0.85,
          }}
        />
      )}

      {/* Output/Input İkonu - output'ta sadece vavien varsa, input'ta her zaman */}
      {(
        (component.type === 'output' && inputs.some(input => input.vavienoutput === component.socketpin)) ||
        component.type === 'input'
      ) && (
        <img
          src={VectorOutputInput}
          alt="output-input"
          style={{
            position: 'absolute',
            top: component.type === 'output'
              ? `calc(6.67px + ${firstRowIconSize.iconSize} * 0.38 + 4px)`
              : '6.67px',
            right: '6.67px',
            width: `calc(${firstRowIconSize.iconSize} * 0.38)`,
            height: `calc(${firstRowIconSize.iconSize} * 0.38)`,
            opacity: 0.85,
          }}
        />
      )}

      {/* Pikacu İkonu - Sağ üst (sadece voltage) */}
      {component.type === 'voltage' && (
        <img
          src={PikacuIcon}
          alt="voltage"
          style={{
            position: 'absolute',
            top: '6.67px',
            right: '6.67px',
            width: `calc(${firstRowIconSize.iconSize} * 0.38)`,
            height: `calc(${firstRowIconSize.iconSize} * 0.38)`,
            opacity: 0.85,
          }}
        />
      )}

      {/* Float İkonu - Sağ üst (sadece float) */}
      {component.type === 'float' && (
        <img
          src={FloatIkon}
          alt="float"
          style={{
            position: 'absolute',
            top: '6.67px',
            right: '6.67px',
            width: `calc(${firstRowIconSize.iconSize} * 0.38)`,
            height: `calc(${firstRowIconSize.iconSize} * 0.38)`,
            opacity: 0.85,
          }}
        />
      )}

      {/* Socket Pin - Aşağıda */}
      <div style={{
        position: 'absolute',
        bottom: '22px',
        left: '4px',
        backgroundColor: '#ff9800',
        color: 'white',
        padding: '2px 6px',
        borderRadius: '4px',
        fontSize: '8px',
        fontWeight: 'bold',
        border: '1px solid #f57c00'
      }}>
        {component.socketpin}
      </div>


      {/* Mevcut icon ve text kodları */}
      {(component.type === 'float' || icons[component.icon]) && (
        <div style={{
          position: 'absolute',
          ...(component.type === 'voltage'
            ? { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: firstRowIconSize.width, height: firstRowIconSize.height }
            : component.type === 'float'
            ? { top: '43%', left: '50%', transform: 'translate(-50%, -50%)', width: firstRowIconSize.width, height: firstRowIconSize.height }
            : { top: '6.67px', left: '6.67px', width: firstRowIconSize.width, height: firstRowIconSize.height }
          ),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <img
            src={component.type === 'float' ? WaterIcon : icons[component.icon]}
            alt={component.name}
            style={{
              width: component.type === 'float' ? `calc(${firstRowIconSize.iconSize} * 0.80)` : component.type === 'voltage' ? `calc(${firstRowIconSize.iconSize} * 0.55)` : firstRowIconSize.iconSize,
              height: component.type === 'float' ? `calc(${firstRowIconSize.iconSize} * 1.05)` : component.type === 'voltage' ? `calc(${firstRowIconSize.iconSize} * 0.55)` : firstRowIconSize.iconSize,
            }}
          />
        </div>
      )}
      <Text style={{
        position: 'absolute',
        bottom: '8px',
        left: 0,
        right: 0,
        fontSize: '12px',
        textAlign: 'center',
        lineHeight: firstRowCapacity > 6 ? '12px' : '14px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontWeight: '500',
        color: '#ffffff'
      }}>
        {component.name}
      </Text>
      {component.isClone && (
  <div
    style={{
      position: 'absolute',
      top: '50%',
      left: '4px',
      transform: 'translateY(-50%)',
      width: '20px',
      height: '20px',
      backgroundColor: '#52c41a',
      borderRadius: '50%',
      fontSize: '11px',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      boxShadow: '0 2px 6px rgba(82, 196, 26, 0.3)'
    }}
  >
    C
  </div>
)}

    </>
) : (
  <div 
    style={{ textAlign: 'center', cursor: 'pointer' }}
    onClick={() => onEmptySlotClick && onEmptySlotClick(page, 1, i + 1)}
  >
    <div style={{
      width: '40px',
      height: '40px',
      border: '2px dashed #d9d9d9',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: firstRowCapacity > 6 ? '2px' : '4px',
      color: '#999',
      fontSize: '14px',
      transition: 'all 0.3s ease'
    }}>
      +
    </div>
    <Text style={{ fontSize: '11px', color: '#999' }}>
      {t('boşslato')} 
    </Text>
  </div>
)}
</div>

                );
              })}
            </div>
          </div>
        )}

        {/* İkinci sıra - Kompakt */}
        {secondRowCapacity > 0 && (
  <div style={{ marginBottom: '12px' }}>
    <Text style={{ fontSize: '12px', color: '#666', fontWeight: 'bold' }}>{t('sıraiki')} </Text>
    <div style={{ 
      display: 'flex', 
      gap: secondRowGap, 
      marginTop: '4px',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      overflow: 'hidden'
    }}>
      {Array.from({ length: secondRowCapacity }, (_, i) => {
        const component = getComponentAtPosition(page, 2, i + 1);
        return (
          <div
            key={`row2-col${i + 1}`}
            onClick={() => component && onComponentClick && onComponentClick(component)}
            style={{
              width: secondRowSize.width,
              height: secondRowSize.height,
              border: '1px solid #2C2F3B',
              borderRadius: '10px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              background: (component?.type === 'voltage' || component?.type === 'float') ? '#2325304D' : 'linear-gradient(225deg, #404040 0%, #202020 100%)',
              position: 'relative',
              cursor: component ? 'pointer' : 'default',
              transition: 'all 0.3s ease',
              boxShadow: component ? '0 4px 12px rgba(24, 144, 255, 0.15)' : '0 2px 8px rgba(0, 0, 0, 0.06)',
              flexShrink: 0,

            }}
            title={component ? `${component.name} (${component.type.toUpperCase()})` : `Kolon ${i + 1}`}
          >
            {component ? (
              <>

                {/* Voltage Göstergesi - Yarım Halka (SVG arc) */}
                {component.type === 'voltage' && (
                  <svg
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }}
                    viewBox="0 0 130 130"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <linearGradient id={`vg2-${component.socketpin}`} x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%"   stopColor="#FF0000" />
                        <stop offset="35%"  stopColor="#FFD300" />
                        <stop offset="65%"  stopColor="#7BFF00" />
                        <stop offset="100%" stopColor="#00FF00" />
                      </linearGradient>
                    </defs>
                    <path
                      d="M 11 65 A 54 54 0 0 1 119 65"
                      stroke="rgba(255,255,255,0.08)"
                      strokeWidth="11"
                      fill="none"
                      strokeLinecap="round"
                    />
                    <path
                      d="M 11 65 A 54 54 0 0 1 119 65"
                      stroke={`url(#vg2-${component.socketpin})`}
                      strokeWidth="11"
                      fill="none"
                      strokeLinecap="round"
                    />
                  </svg>
                )}

                {/* Power Button İkonu - Sağ üst (sadece output) */}
                {component.type === 'output' && (
                  <img
                    src={VectorPowerButton}
                    alt="power"
                    style={{
                      position: 'absolute',
                      top: '6.67px',
                      right: '6.67px',
                      width: `calc(${secondRowIconSize.iconSize} * 0.38)`,
                      height: `calc(${secondRowIconSize.iconSize} * 0.38)`,
                      opacity: 0.85,
                    }}
                  />
                )}

                {/* Output/Input İkonu - output'ta sadece vavien varsa, input'ta her zaman */}
                {(
                  (component.type === 'output' && inputs.some(input => input.vavienoutput === component.socketpin)) ||
                  component.type === 'input'
                ) && (
                  <img
                    src={VectorOutputInput}
                    alt="output-input"
                    style={{
                      position: 'absolute',
                      top: component.type === 'output'
                        ? `calc(6.67px + ${secondRowIconSize.iconSize} * 0.38 + 4px)`
                        : '6.67px',
                      right: '6.67px',
                      width: `calc(${secondRowIconSize.iconSize} * 0.38)`,
                      height: `calc(${secondRowIconSize.iconSize} * 0.38)`,
                      opacity: 0.85,
                    }}
                  />
                )}

                {/* Pikacu İkonu - Sağ üst (sadece voltage) */}
                {component.type === 'voltage' && (
                  <img
                    src={PikacuIcon}
                    alt="voltage"
                    style={{
                      position: 'absolute',
                      top: '6.67px',
                      right: '6.67px',
                      width: `calc(${secondRowIconSize.iconSize} * 0.38)`,
                      height: `calc(${secondRowIconSize.iconSize} * 0.38)`,
                      opacity: 0.85,
                    }}
                  />
                )}

                {/* Float İkonu - Sağ üst (sadece float) */}
                {component.type === 'float' && (
                  <img
                    src={FloatIkon}
                    alt="float"
                    style={{
                      position: 'absolute',
                      top: '6.67px',
                      right: '6.67px',
                      width: `calc(${secondRowIconSize.iconSize} * 0.38)`,
                      height: `calc(${secondRowIconSize.iconSize} * 0.38)`,
                      opacity: 0.85,
                    }}
                  />
                )}

                {/* Socket Pin - Aşağıda */}
                <div style={{
                  position: 'absolute',
                  bottom: '22px',
                  left: '4px',
                  backgroundColor: '#ff9800',
                  color: 'white',
                  padding: '2px 6px',
                  borderRadius: '4px',
                  fontSize: '8px',
                  fontWeight: 'bold',
                  border: '1px solid #f57c00'
                }}>
                  {component.socketpin}
                </div>



                {(component.type === 'float' || icons[component.icon]) && (
                  <div style={{
                    position: 'absolute',
                    ...(component.type === 'voltage'
                      ? { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: secondRowIconSize.width, height: secondRowIconSize.height }
                      : component.type === 'float'
                      ? { top: '43%', left: '50%', transform: 'translate(-50%, -50%)', width: secondRowIconSize.width, height: secondRowIconSize.height }
                      : { top: '6.67px', left: '6.67px', width: secondRowIconSize.width, height: secondRowIconSize.height }
                    ),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img
                      src={component.type === 'float' ? WaterIcon : icons[component.icon]}
                      alt={component.name}
                      style={{
                        width: component.type === 'float' ? `calc(${secondRowIconSize.iconSize} * 0.80)` : component.type === 'voltage' ? `calc(${secondRowIconSize.iconSize} * 0.55)` : secondRowIconSize.iconSize,
                        height: component.type === 'float' ? `calc(${secondRowIconSize.iconSize} * 1.05)` : component.type === 'voltage' ? `calc(${secondRowIconSize.iconSize} * 0.55)` : secondRowIconSize.iconSize,
                      }}
                    />
                  </div>
                )}
                <Text style={{
                  position: 'absolute',
                  bottom: '8px',
                  left: 0,
                  right: 0,
                  fontSize: '12px',
                  textAlign: 'center',
                  lineHeight: secondRowCapacity > 6 ? '12px' : '14px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontWeight: '500',
                  color: '#ffffff'
                }}>
                  {component.name}
                </Text>
                {component.isClone && (
  <div
    style={{
      position: 'absolute',
      top: '50%',
      left: '4px',
      transform: 'translateY(-50%)',
      width: '20px',
      height: '20px',
      backgroundColor: '#52c41a',
      borderRadius: '50%',
      fontSize: '11px',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      boxShadow: '0 2px 6px rgba(82, 196, 26, 0.3)'
    }}
  >
    C
  </div>
)}

              </>
) : (
  <div 
    style={{ textAlign: 'center', cursor: 'pointer' }}
    onClick={() => onEmptySlotClick && onEmptySlotClick(page, 2, i + 1)}
  >
    <div style={{
      width: '40px',
      height: '40px',
      border: '2px dashed #d9d9d9',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: secondRowCapacity > 6 ? '2px' : '4px',
      color: '#999',
      fontSize: '14px',
      transition: 'all 0.3s ease'
    }}>
      +
    </div>
    <Text style={{ fontSize: '11px', color: '#999' }}>
      {t('boşslato')} 
    </Text>
  </div>
)}
          </div>
        );
      })}
    </div>
  </div>
)}

        </div>{/* wrapper sonu */}

        {/* Eğer sayfa boşsa */}
        {firstRowCapacity === 0 && secondRowCapacity === 0 && (
          <div style={{ 
            textAlign: 'center', 
            color: '#999', 
            marginTop: '30px',
            fontSize: '14px'
          }}>
            <div style={{
              width: '70px',
              height: '70px',
              border: '3px dashed #d9d9d9',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 10px',
              fontSize: '28px'
            }}>
              📱
            </div>
            {t('busayfaiçin')} 
          </div>
        )}
      </div>
    );

    
  };

  // Hover durumunda gösterilecek detay paneli ekle (renderPage fonksiyonu sonuna):
{hoveredComponent && (
  <div style={{
    position: 'absolute',
    bottom: '10px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    zIndex: 1000,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
  }}>
    <div><strong>{hoveredComponent.name}</strong></div>
    <div style={{ fontSize: '10px', marginTop: '4px' }}>
      Pin: {hoveredComponent.socketpin} | Tip: {hoveredComponent.type.toUpperCase()}
      {hoveredComponent.isClone && ' | KLON'}
    </div>
  </div>
)}

  return (
    <Card 
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>{t('panelönizleme')}</span>
<Button
  type="primary"
  size="middle"
  icon={<PlusOutlined />}
  onClick={handleAddNewPage}
  style={{ height: 30, fontSize: 13, padding: '0 12px' }}
>
  {t('sayfaekle') || 'Sayfa Ekle'}
</Button>
        </div>
      } 
      headStyle={{ borderRadius: '8px 8px 0 0' }}
    >
      {pages.length > 0 ? (
        <Tabs 
          activeKey={selectedPage.toString()} 
          onChange={(key) => setSelectedPage(parseInt(key))}
          type="card"
          size="large"
        >
          {pages.map(page => (
            <TabPane 
              tab={
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  {t('sayifaaaapanel')}  {page.no}
                  {/* {page.name && page.name !== '-' ? ` - ${page.name}` : ''} */}
                  <div style={{ display: "flex", gap: "4px" }}>
                    {/* <Button 
                      type="text" 
                      size="small" 
                      icon={<SettingOutlined />}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenPageSettings(page);
                      }}
                      style={{ padding: "0 4px", height: "20px" }}
                    /> */}
                    {pages.length > 1 && (
                      <Popconfirm
                        title={t('pagepreqiew')}
                        onConfirm={(e) => {
                          e?.stopPropagation();
                          handleDeletePage(page.no);
                        }}
                        okText={t('ssilmekteeneminmisinizpalnelprewiewevet')}
                        cancelText={t('ssilmekteeneminmisinizpalnelprewiewhayır')}
                      >
                        <Button 
                          type="text" 
                          size="small" 
                          icon={<DeleteOutlined />}
                          onClick={(e) => e.stopPropagation()}
                          style={{ padding: "0 4px", height: "20px", color: "#ff4d4f" }}
                        />
                      </Popconfirm>
                    )}
                  </div>
                </div>
              } 
              key={page.no.toString()}
            >
              {renderPage(page.no)}
            </TabPane>
          ))}
        </Tabs>
      ) : (
        <div style={{ 
          textAlign: 'center', 
          color: '#999', 
          padding: '60px',
          border: '3px dashed #d9d9d9',
          borderRadius: '12px',
          backgroundColor: '#fafafa'
        }}>
          <div style={{
            width: '120px',
            height: '120px',
            border: '3px dashed #d9d9d9',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            fontSize: '48px'
          }}>
            📋
          </div>
          <Title level={4} style={{ color: '#999' }}>{t('henüzsayfaeklenmemiş')}</Title>
          <Text style={{ fontSize: '14px' }}>{t('önizlemeiçinsayfaekleyinkapesite')}</Text>
        </div>
      )}

      {/* Sayfa Ayarları Modalı */}
      <Modal
        title={t('sayfaayarlarıpanelprewierw')}
        visible={pageSettingsModalVisible}
        onCancel={() => {
          setPageSettingsModalVisible(false);
          setEditingPage(null);
          form.resetFields();
        }}
        onOk={handleSavePageSettings}
        okText={t('kaydetpanelprewiew')}
        cancelText={t('iptalpanelprewiew')}
      >
        <Form
          form={form}
          layout="vertical"
        >
          <Form.Item
            label={t('sayfadıpanelprewiew')}
            name="name"
          >
            <Input placeholder={t('sayfadıgirinpanelprwiew')} />
          </Form.Item>
          
          <Form.Item
            label={t('birincisırapestasipanelpreewiew')}
            name="first_row_capacity"
            rules={[
              { required: true, message: `${t('birincisırakpesitesizorunlu')}` },
              { type: "number", min: 0, max: 5, message: `${t('değergirinzorunlu')}` }
            ]}
          >
            <InputNumber
              min={0}
              max={5}
              placeholder={t('birincisıraiçinkolonsayisi')}
              style={{ width: "100%" }}
            />
          </Form.Item>
          
          <Form.Item
            label={t('ikincisırakapesitesi')}
            name="second_row_capacity"
            rules={[
              { required: true, message: `${t('ikincisırakpesitesizorunlu')}` },
              { type: "number", min: 0, max: 5, message: `${t('değergirikincipageprewiew')}` }
            ]}
          >
            <InputNumber
              min={0}
              max={5}
              placeholder={t('ikincisıraiçinkolonsırayısı')}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};

export default PanelPreview;